import { render, staticRenderFns } from "./PowraB.vue?vue&type=template&id=720ffd01&scoped=true&"
import script from "./PowraB.vue?vue&type=script&lang=js&"
export * from "./PowraB.vue?vue&type=script&lang=js&"
import style0 from "./PowraB.vue?vue&type=style&index=0&id=720ffd01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ffd01",
  null
  
)

export default component.exports